/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Form, Input } from 'semantic-ui-react'

export default class TimeField extends React.PureComponent {
  onTimeChange = (hour, field, value) => {
    const { onFieldChange } = this.props

    onFieldChange(hour, field, value)
  }

  render() {
    const { time, firstRow, timeSlot } = this.props
    const firstRowTopMargin = firstRow ? 17 : 0
    const hour = Number(moment(time, 'h:mm A').format('HH'))

    const distanceValue =  _.get(timeSlot, `[${hour}][distance_to_store]`, 0)
    const minuteValue = _.get(timeSlot, `[${hour}][distance_travel_per_min]`, 0)

    return (
      <Form.Group>
        <label
          style={{
            marginTop: `${firstRowTopMargin}px`,
            width: 80,
            marginRight: 60,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {time}
        </label>
        <Form.Field
          width={2}
          {...(firstRow ? { label: 'Distance to Store (in meter)' } : {})}
          control={Input}
          type="number"
          onChange={e => this.onTimeChange(hour, 'distance_to_store', e.target.value)}
          // eslint-disable-next-line radix
          value={parseInt(distanceValue)}
        />
        <Form.Field
          width={2}
          {...(firstRow ? { label: 'Distance travel per minute (in meter)' } : {})}
          control={Input}
          type="number"
          onChange={e => this.onTimeChange(hour, 'distance_travel_per_min', e.target.value)}
          // eslint-disable-next-line radix
          value={parseInt(minuteValue)}
        />
      </Form.Group>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/configurations/Driver/components/TimeField.js